import netlifyIdentity from 'netlify-identity-widget/build/netlify-identity'

const initNetlify = () => {
  netlifyIdentity.init({
    APIUrl: 'https://cfstudio.netlify.app/.netlify/identity',
  })
}

export default initNetlify
